import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-client-lowest-tickets',
  templateUrl: './client-lowest-tickets.component.html',
  styleUrls: ['./client-lowest-tickets.component.css']
})
export class ClientLowestTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.ClientsLowestTickets();
  }

  ClientsLowestTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.clientsLowestTickets()
    .subscribe((data:any)=>{
      this.ClientList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/client-lowest-tickets/client-lowest-tickets.component.ts